import { render, staticRenderFns } from "./LayoutArquivoRetornoModal.vue?vue&type=template&id=5024a05f&scoped=true&"
import script from "./LayoutArquivoRetornoModal.vue?vue&type=script&lang=js&"
export * from "./LayoutArquivoRetornoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024a05f",
  null
  
)

export default component.exports